import BlCardMv from './BlCardMv.vue'

BlCardMv.install = function(Vue) {
  Vue.component(BlCardMv.name, BlCardMv)
}

export default BlCardMv
